import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserNavbar from '../components/UserNavbar';
import UserDashboard from '../pages/user/UserDashboard';
import BusinessForm from '../pages/BusinessForm';
import ProfileForm from '../pages/ProfileForm';

const UserLayout = () => {
    return (
        <div className="min-h-screen bg-gray-100">
            <UserNavbar />
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <Routes>
                    <Route path="/" element={<UserDashboard />} />
                    
                    {/* Routes for creating and editing businesses and profiles */}
                    <Route path="/business/new" element={<BusinessForm />} />
                    <Route path="/business/edit/:id" element={<BusinessForm />} />
                    <Route path="/profile/new" element={<ProfileForm />} />
                    <Route path="/profile/edit/:id" element={<ProfileForm />} />

                    {/* Add other user-specific routes here, e.g., /account */}
                </Routes>
            </main>
        </div>
    );
};

export default UserLayout;